import type { RailTopic } from './railTopic.js';

/**
 * Las tres casillas de la tarjeta del coach en el panel izquierdo de la charla
 * (compu): nivel, turnos y la escena o el tema.
 *
 * Con el nombre de una escena («Pedir indicaciones», hasta 39 letras) la tercera
 * no entra al lado de las otras dos y se salía 14 px de la tarjeta (prueba de la
 * #600, 21/10): la fila se parte y la casilla baja a su renglón, con todo el
 * ancho. Lo mide `e2e/narrow-sheets.spec.ts`.
 */
export function RailMeta({
  level,
  turns,
  topic,
}: {
  level: string;
  turns: number;
  topic: RailTopic;
}) {
  return (
    <div className="dt-conv-meta">
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          gap: '10px 12px',
        }}
      >
        <div>
          <div className="tag" style={{ color: 'var(--text-muted)' }}>
            NIVEL
          </div>
          <div className="dt-conv-meta-val">{level}</div>
        </div>
        <div>
          <div className="tag" style={{ color: 'var(--text-muted)' }}>
            TURNOS
          </div>
          <div className="dt-conv-meta-val">{turns}</div>
        </div>
        <div>
          <div className="tag" style={{ color: 'var(--text-muted)' }}>
            {topic.kicker}
          </div>
          <div
            className="dt-conv-meta-val"
            style={topic.color ? { color: topic.color } : undefined}
          >
            {topic.label}
          </div>
        </div>
      </div>
    </div>
  );
}
